import { render, staticRenderFns } from "./CaseActions.vue?vue&type=template&id=4538ead5"
import script from "./CaseActions.vue?vue&type=script&lang=js"
export * from "./CaseActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports